import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DivIcon from 'react-leaflet-div-icon';
import _ from 'lodash';
import { zoomByCoordinates } from './../../actions/parkingSpots';
import { anyFilterSet } from './../../utils';

class ParkingAreaMarker extends Component {

  renderLayerWithFilters() {
    const {validSpots, allOpenSpots, feature} = this.props;
    const { name, ltype } = feature.properties;

    return ltype === 'poi' 
      ? (
        <div className="marker-group">
          {(validSpots.length > 0) && <div className="label-info" data-number={validSpots.length} />}
          <span className="label label-default">{name}</span>
        </div>
      )
      : (
        <div className="marker-group">
          {(validSpots.length > 0) && <div className="label-info" data-number={validSpots.length} />}
          <span className="label label-default">{name} ({allOpenSpots.length})</span>
        </div>
      );
  }

  renderLayerWithoutFilters() {
    const {allOpenSpots, feature} = this.props;
    const { name, ltype } = feature.properties;

    return ltype === 'poi'
      ? (
        <div className="marker-group">
          <span className="label label-default">{name}</span>
        </div>
      )
      : (
        <div className="marker-group">
          <span className="label label-default">{name} ({allOpenSpots.length})</span>
        </div>
      );
  }

  render() {
    const { feature, allOpenSpots, zoomByCoordinates, isFilterApplied } = this.props;

    return (
      <DivIcon position={feature.centerCoordinates}
               onClick={() => zoomByCoordinates(feature.centerCoordinates)}
               className={`${allOpenSpots.length ? `` : `marker-invalid-group`}`}>
        {isFilterApplied ? this.renderLayerWithFilters() : this.renderLayerWithoutFilters() }
      </DivIcon>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { feature } = ownProps;
  const { name } = feature.properties;
  const spots = state.session.areaSpotsMapList[name] || [];
  const parkingSpotsList =  state.parkingSpots.list;
  const { allFilteredSpots, isFilterApplied } = state.search;
  let allOpenSpots = [];

  spots.forEach(spotId => {
    if(parkingSpotsList.hasOwnProperty(spotId)) {
      const spot = parkingSpotsList[spotId];
      if(spot.status === 'OPEN'){
        allOpenSpots.push(spotId);
      }
    }
  });

  let validSpots = [];
  if(anyFilterSet()) {
    validSpots = isFilterApplied ? _.intersection(allFilteredSpots, allOpenSpots) : allOpenSpots;
  }

  return {
    parkingSpotsList,
    validSpots,
    isFilterApplied,
    allOpenSpots
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ zoomByCoordinates }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkingAreaMarker);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ParkingAreaMarker.js